<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer un nouveau module</strong>
          </div>
          <b-form>
            <b-form-group label="Nom" label-for="basicName">
              <b-form-input
                id="basicName"
                type="text"
                autocomplete="name"
                :class="{hasError: errors.nom !== ''}"
                v-model="nom"
              />
              <span class="field-error">{{ errors.nom }}</span>
            </b-form-group>
            <b-form-group label="Espace" label-for="basicSelect">
              <b-form-select
                id="basicSelect"
                :plain="true"
                :options="espacesOptions"
                v-model="selectedEspace">
              </b-form-select>
              <span class="field-error">{{ errors.selectedEspace }}</span>
            </b-form-group>
            <b-form-group label="Ordre" label-for="ordre">
              <b-form-input
                id="ordre"
                type="number"
                :class="{hasError: errors.ordre !== ''}"
                v-model="ordre"
              />
              <span class="field-error">{{ errors.ordre }}</span>
            </b-form-group>
            <b-form-group label="Description" label-for="description">
              <b-form-textarea
                id="description"
                type="text"
                :class="{hasError: errors.description !== ''}"
                rows="3"
                max-rows="6"
                v-model="description">
              </b-form-textarea>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des modules
              </b-button>
              <b-button type="button" @click="saveModule" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  export default {
    name: "CreateModule",
    data() {
      return {
        nom: "",
        selectedEspace: null,
        ordre: 0,
        description: "",
        espacesOptions: [],
        errors: {
          nom: "",
          selectedEspace: "",
          ordre: "",
          description: "",
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getEspaces();
    },
    methods: {
      getEspaces() {
        let self = this;
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/administration/espaces')
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            const espaces = response.data.espaces;
            for (let i = 0; i < espaces.length; i++) {
              this.espacesOptions.push({
                text: espaces[i].nom,
                value: espaces[i].id
              });
            }
          })
          .catch(() => {
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Un problème est survenu, merci de contacter l\'administrateur',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
      saveModule() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let self = this;
          let dataPost = {};
          dataPost.nom = this.nom;
          dataPost.ordre = this.ordre;
          dataPost.espace_id = this.selectedEspace;
          dataPost.description = this.description;
          this.$axios
            .post("/administration/modules", dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Création avec succès",
                text: "Le module a été bien crée ",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack()
            })
            .catch((error) => {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: error,
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/administration/modules"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;
        if (this.nom === "") {
          this.errors.nom = "Le nom est obligatoire";
          valid = false;
        }
        if (this.selectedEspace === null) {
          this.errors.selectedEspace = "L'espace est obligatoire";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.nom = "";
        this.errors.ordre = "";
        this.errors.description = "";
      }
    }
  }
</script>
